import React from "react";
import SettingsLayout from "layouts/settings";

const OrganizationSettings = () => {
  return (
    <SettingsLayout 
      settingsType="organization" 
      basePath="/dashboard/organization-settings"
    />
  );
};

export default OrganizationSettings;
